import { render, staticRenderFns } from "./CertificateDesigner.vue?vue&type=template&id=f5b77594&scoped=true"
import script from "./CertificateDesigner.vue?vue&type=script&lang=js"
export * from "./CertificateDesigner.vue?vue&type=script&lang=js"
import style0 from "./CertificateDesigner.vue?vue&type=style&index=0&id=f5b77594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b77594",
  null
  
)

export default component.exports